export const DEFAULT_SCENE = 'real-time-adherence';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;

const LIST = `${DEFAULT_SCENE}:list`;
export const LIST_CONTAINER_TAG = `${LIST}:container`;
export const getListHeaderTag = (headerName: string) => `${LIST}:header-${headerName}`;
export const getListItemTag = (order: number, propName: string) => `${LIST}:overviewItem[${order}]-${propName}`;

export const getFieldsInputTag = (fieldName: string) => `${DEFAULT_SCENE}:input-${fieldName}`;

export const LIST_PAGINATION_TAG = `${LIST}:pagination`;

const AGENT_DETAILS = `${DEFAULT_SCENE}:agent-details`;
export const AGENT_DETAILS_CONTAINER_TAG = `${AGENT_DETAILS}:container`;
export const getAgentDetailsItemTag = (propName: string) => `${AGENT_DETAILS}:${propName}`;

export const TRANSITION_DELAY_TIMEOUT = 10000; // value in milliseconds
export const TRANSITION_OUT_DELAY_TIMEOUT = 4000; // value in milliseconds

// Search Real-Time Adherence
const SEARCH_REAL_TIME_ADHERENCE = `${DEFAULT_SCENE}:search-real-time-adherence`;
export const SEARCH_REAL_TIME_ADHERENCE_CONTAINER_TAG = `${SEARCH_REAL_TIME_ADHERENCE}:container`;
export const SEARCH_REAL_TIME_ADHERENCE_RESET_BUTTON_TAG = `${SEARCH_REAL_TIME_ADHERENCE}:button-reset`;

export const getSearchFieldsInputTag = (fieldName: string) => `${SEARCH_REAL_TIME_ADHERENCE}:input-${fieldName}`;

// SideBar Filter
const FILTER_SIDEBAR = `${DEFAULT_SCENE}:filter-sidebar`;
export const TOGGLE_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-toggle`;
export const APPLY_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-apply`;
export const FILTER_SIDEBAR_DROPDOWN_TOGGLE = `${FILTER_SIDEBAR}:dropdown-toggle`;
export const RESET_ALL_SIDEBAR_FILTERS_BUTTON_TAG = `${FILTER_SIDEBAR}:reset-all-filters`;
export const ACTIVE_SIDEBAR_FILTERS_COUNTER = `${FILTER_SIDEBAR}:active-filters-counter`;
